<template>
  <main role="Negoisasi">
    <div class="row">
      <div class="card">
        <div class="card-header">
          <h4>Log {{ dataUser }}</h4>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <div class="card p-4 notifCard">
              <div class="media">
                <img src="./people.jpg" class="mr-3 img-fluid" width="60px" />
                <div class="media-body">
                  <h5 class="mt-2 font-weight-bold mb-0">
                    {{ dataUser }}
                  </h5>
                  <p class="text-muted" style="font-size: 12px">
                    {{ dataUser }}
                  </p>
                  <div class="mb-2">
                    <div class="userAgent">
                      <p class="text-muted" style="font-size: 12px">
                        Ip Address: None
                      </p>
                      <p class="text-muted" style="font-size: 12px">
                        Ip Address: 192.168.1.1
                      </p>
                      <h5 class="font-weight-bold">Riwayat Aksi</h5>
                      <p class="text-muted" style="font-size: 12px">
                        <!-- - Telah Mengubah produk yang bernama Erlangga Fokus AKM
                        pada tanggal 20 Januari 2020 <br class="mb-2" />
                        - Telah menyetujui negoisasi untuk invoice
                        <a class="">201912912</a> pada tanggal 20 Januari 2020 -->
                        None
                      </p>
                      <p class="text-muted" style="font-size: 12px">
                        <!-- {{ dataUser }} -->
                      </p>
                    </div>
                  </div>

                  <!-- <small class="text">Hari ini / 2021</small> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      dataUser: "",
    };
  },
  mounted() {
    this.dataUser = this.$route.params.id;
    // this.dataUser = "Angga";
  },
};
</script>